import { SET_INSTRUMENT, RECEIVE_INSTRUMENTS, REQUEST_INSTRUMENTS } from '../actions/instrumentActions';
var initialState = {
  instruments: [],
  selectedInstrumentId: undefined,
  fetching: true
};
export default function intsrumentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case SET_INSTRUMENT:
      return handleSeInstrument(state, payload);
    case REQUEST_INSTRUMENTS:
      return Object.assign({}, state, {
        fetching: true
      });
    case RECEIVE_INSTRUMENTS:
      return handleReceiveInstruments(state, payload);
    default:
      return state;
  }
}
function handleSeInstrument(state, selectedInstrumentId) {
  return Object.assign({}, state, {
    selectedInstrumentId: selectedInstrumentId
  });
}
function handleReceiveInstruments(state, instruments) {
  var update = {
    fetching: false,
    instruments: instruments
  };
  return Object.assign({}, state, update);
}